import { useState } from "react";
import { ShipTier, ShipTierColors, ShipTierNames } from "@voidex/contracts-ts";
import { useShipPrices } from "../../hooks";
import { HudDivider, ShipIcon } from "../shared";
import { ShipBuyCard } from "./ShipBuyCard";

const TIERS = [ShipTier.Probe, ShipTier.Frigate, ShipTier.Dreadnought] as const;

export function ShipBuySection() {
	const [selectedTier, setSelectedTier] = useState<ShipTier>(ShipTier.Probe);
	const {
		probePrice,
		frigatePrice,
		dreadnoughtPrice,
		formattedProbePrice,
		formattedFrigatePrice,
		formattedDreadnoughtPrice,
		isLoading,
	} = useShipPrices();

	const priceMap: Record<ShipTier, bigint> = {
		[ShipTier.Probe]: probePrice,
		[ShipTier.Frigate]: frigatePrice,
		[ShipTier.Dreadnought]: dreadnoughtPrice,
	};
	const formattedPriceMap: Record<ShipTier, string> = {
		[ShipTier.Probe]: formattedProbePrice,
		[ShipTier.Frigate]: formattedFrigatePrice,
		[ShipTier.Dreadnought]: formattedDreadnoughtPrice,
	};

	if (isLoading) {
		return (
			<section className="ship-buy-section">
				<HudDivider label="ACQUIRE SHIPS" />
				<div className="ship-showcase__loading">Loading prices...</div>
			</section>
		);
	}

	return (
		<section className="ship-buy-section">
			<HudDivider label="ACQUIRE SHIPS" />
			<div className="ship-showcase__selector">
				{TIERS.map((tier) => (
					<button
						key={tier}
						type="button"
						className={`ship-showcase__thumb ${selectedTier === tier ? "ship-showcase__thumb--active" : ""}`}
						style={
							{
								"--thumb-color": ShipTierColors[tier],
							} as React.CSSProperties
						}
						onClick={() => setSelectedTier(tier)}
					>
						<ShipIcon tier={tier} size="md" />
						<span className="ship-showcase__thumb-label">{ShipTierNames[tier]}</span>
					</button>
				))}
			</div>
			<ShipBuyCard
				key={selectedTier}
				tier={selectedTier}
				price={priceMap[selectedTier]}
				formattedPrice={formattedPriceMap[selectedTier]}
			/>
		</section>
	);
}
